import React from 'react';
import { SettingDisplayText } from 'components/settings/SettingDisplayText';
import { SettingDisplayPassword } from 'components/settings/SettingDisplayPassword';
import { IDeliveryProviderSettingsProps } from 'components/settings/DeliverySettings';

export const UberDirectSettingsDisplay: React.FC<IDeliveryProviderSettingsProps> = ({
    settings,
    locationId
}) => {
    const customerIdDisplay = React.useMemo(() => {
        if (locationId !== undefined) {
            return settings?.uberDirect?.customerId ?? 'Unset (currently uses GLOBAL setting)';
        }
        return settings?.uberDirect?.customerId;
    }, [locationId, settings?.uberDirect?.customerId]);

    return (
        <>
            <SettingDisplayText title="Customer ID" variant="body1" text={customerIdDisplay} />
            {locationId === undefined && (
                <>
                    <SettingDisplayText
                        title="Client ID"
                        variant="body1"
                        text={settings?.uberDirect?.clientId}
                    />
                    <SettingDisplayPassword
                        title="Client Secret"
                        variant="body1"
                        text={settings?.uberDirect?.clientSecret}
                    />
                    <SettingDisplayPassword
                        title="Webhook Secret"
                        variant="body1"
                        text={settings?.uberDirect?.webhookSecret}
                    />
                </>
            )}
        </>
    );
};
